const statuses = {
    open: {
        name: 'À réceptionner',
        dotColor: 'pink',
    },
    closed: {
        name: 'Terminé',
        dotColor: 'green',
    },
    canceled: {
        name: 'Annulé',
        dotColor: 'red',
    },
}

export function statusName(status) {
    return statuses[status]?.name || ''
}

export function statusDotColor(status) {
    return statuses[status]?.dotColor || 'gray'
}
